import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function EmptyState({ title = 'Sem dados', description, actionLabel, onAction }) {
  return (
    <Box textAlign="center" p={4}>
      <Typography variant="h6" sx={{ mb: 1 }}>{title}</Typography>
      {!!description && <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{description}</Typography>}
      {actionLabel && onAction && (
        <Button variant="outlined" onClick={onAction}>{actionLabel}</Button>
      )}
    </Box>
  );
}

